import { apiGet, apiPatch } from './client';
import type { Category, CategoryBatchRequest } from '../types/Category';

export function getCategories(): Promise<Category[]> {
  return apiGet<Category[]>('/api/categories');
}

export function saveBatchCategories(
  added: Category[],
  modified: Category[],
  deletedIds: number[],
): Promise<Category[]> {
  return apiPatch<CategoryBatchRequest, Category[]>('/api/categories/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
